import {
  ArtifactOrgShare,
  ArtifactPositionShare,
  ArtifactShare
} from '../../forgeApi.types'

export interface GetArtifactSharesRaw {
  shares?: ArtifactShare[]
  org_shares?: ArtifactOrgShare[]
  position_shares?: ArtifactPositionShare[]
}

export interface GetArtifactSharesResponse {
  users: ArtifactShare[]
  orgs: ArtifactOrgShare[]
  positions: ArtifactPositionShare[]
}
